import { AxiosInstance } from 'axios'

export type Term = {
  id: number
  pharmaceuticalId: number
  version: number
  url: string
}

type CheckUserAcceptedLatestTerm = {
  pharmaceuticalLatestTerm: Term
  userPharmaceuticalLatestTerm?: Term
  checked: boolean
}

export function termEndpoints(apiClient: AxiosInstance) {
  return {
    accept(termId: number): Promise<{ token: string }> {
      return apiClient.post('term/accept', { termId })
    },
    acceptUnauthenticated(userId: number, termId: number): Promise<void> {
      return apiClient.post('term/accept-unauthenticated', { userId, termId })
    },
    checkUserAcceptedLatestTerm(): Promise<CheckUserAcceptedLatestTerm> {
      return apiClient.get('term/user-accepted-pharmaceutical-latest-term')
    },
    getLatestPharmaceuticalTerm(pharmaceuticalId: number): Promise<Term | undefined> {
      return apiClient.get(`term/latest-by-pharmaceutical/${pharmaceuticalId}`)
    },
  }
}
